module.exports = __webpack_public_path__ + "img/swiper_07.45d5077e.jpg";